<template>
  <div v-if="tipo && clave">
    <DataTable
      :value="documentos"
      :loading="loading"
      :lazy="true"
      :paginator="true"
      :rows="tamPagina"
      :totalRecords="totalRecords"
      class="datatable-responsive"
      :filters.sync="filters"
      selectionMode="single"
      dataKey="id"
      @page="onPage($event)"
      @sort="customSort($event)"
      :autoLayout="true"
    >
      <template #header>
        <div class="grid">
          <div class="col-10 paddingTop10Px">
            <span class="title"
              ><b>{{ header }}</b></span
            >
          </div>
          <div class="col-2">
            <Button
              @click.prevent="mostrarSubirFichero()"
              v-tooltip.bottom="$t('common.buttons.uploadFile')"
              class="
                p-button
                rightAlign
                p-button-icon-only p-button-text
                transparent
              "
              icon="pi pi-upload"
              iconPos="left"
            />
          </div>
        </div>
      </template>
      <template #empty>
        {{ $t("common.noResultados") }}
      </template>

      <Column field="filename" :header="$t('documento.dataTable.filename')">
        <template #body="slotProps">
          {{ slotProps.data.filename }}
        </template>
        <template #filter>
          <InputText type="text" v-model="filters['filename']" />
        </template>
      </Column>
      <Column
        field="fechaAlta"
        :header="$t('documento.dataTable.fechaAlta')"
        :sortable="true"
      >
        <template #body="slotProps">
          {{ getFormattedDateLong(slotProps.data.fechaAlta) }}
        </template>
      </Column>
      <Column field="base64" :header="$t('documento.dataTable.download')">
        <template #body="slotProps">
          <Button
            @click.prevent="descargarArchivo(slotProps.data.id)"
            icon="pi pi-download"
            iconPos="left"
            v-tooltip.bottom="$t('common.descargar')"
            class="p-button-text"
          />
          <Button
            @click.prevent="
              mostrarConfirmacion(
                slotProps.data.id,
                slotProps.data.tipo,
                slotProps.data.clave,
                slotProps.data.filename
              )
            "
            icon="pi pi-trash"
            iconPos="left"
            v-tooltip.bottom="$t('common.buttons.eliminar')"
            class="p-button-text p-button-text-danger"
          />
        </template>
      </Column>
    </DataTable>

    <Confirmacion
      :header="$t('common.mensajes.confirmacionBorrado')"
      :mensajePre="$t('documento.mensajes.borrado')"
      :mensajeNegrita="documentoABorrar.filename"
      mensajePost="?"
      :errores="errorConfirmacionBorrado"
      :displayConfirmation="displayConfirmation"
      v-on:confirmed="borrarArchivo(documentoABorrar.id)"
      v-on:not-confirmed="cerrarModal()"
      :key="'ConfirmacionBorrado' + displayConfirmation"
    />

    <UploadDocument
      :header="$t('common.buttons.uploadFile')"
      :display="this.displayUploadDocument"
      :clave="this.clave"
      :query="queryAltaFichero"
      :key="'UploadFile' + displayUploadDocument"
      @subidaFicheroFinalizada="subidaFicheroFinalizada"
    />
  </div>
</template>


<script>
import DownloadsMixin from "@/utils/downloads";
import DatesMixin from "@/utils/dates";
import {
  GET_FILES_LIST,
  DOWNLOAD_FILE,
  DELETE_FILE_BY_ID,
} from "@/graphQLQueries/DocStoreQueries";
import Confirmacion from "@/components/utilidades/Confirmacion.vue";
import UploadDocument from "@/components/utilidades/UploadDocument.vue";

export const FILTER_SEARCH_FILENAME = "filename";
export const HASH_FICHERO_A_BORRAR = {
  id: null,
  tipo: null,
  clave: null,
  filename: null,
};

export default {
  name: "ListadoDocumentos",
  components: {
    Confirmacion: Confirmacion,
    UploadDocument: UploadDocument,
  },
  props: ["tipo", "clave", "header", "filename", "queryAltaFichero"],
  mixins: [DownloadsMixin, DatesMixin],
  data() {
    return {
      numPagina: 0,
      tamPagina: 5,
      sort: ["-fechaAlta"],
      loading: false,
      totalRecords: 0,
      filters: {},
      documentoABorrar: HASH_FICHERO_A_BORRAR,
      errorConfirmacionBorrado: [],
      displayConfirmation: false,
      displayUploadDocument: false,
    };
  },
  created() {
    this.loading = true;
  },
  computed: {
    backendFilters() {
      var filters2 = [];
      filters2.push(`tipo~eq=` + this.tipo);
      filters2.push(`clave~eq=` + this.clave);
      for (let [key, value] of Object.entries(this.filters)) {
        if (value != null && value != undefined && `${value}`) {
          if ([FILTER_SEARCH_FILENAME].includes(key)) {
            filters2.push(`${key}~ilike=${value}`);
          } else {
            filters2.push(`${key}~ieq=${value}`);
          }
        }
      }
      return filters2;
    },
  },
  methods: {
    search() {
      this.loading = true;
      this.$apollo.queries.documentos.refetch();
    },
    onPage(event) {
      this.numPagina = event.page;
    },
    customSort(event) {
      var sortField = event.sortField;
      var sortOrder = event.sortOrder == -1 ? "-" : "";
      var sortToApply = sortOrder + sortField;
      var sorts = [sortToApply];
      this.sort = sorts;
      this.search();
    },
    descargarArchivo(id) {
      this.$apollo
        .query({
          query: DOWNLOAD_FILE,
          variables: {
            id: id,
          },
        })
        .then((data) => {
          var result = data.data.getFileById;
          this.download(result.filename, result.base64, document);
        })
        .catch(() => {
          this.$toast.add({
            severity: "error",
            summary: this.$t(
              "consulta.detalleConsulta.mensajes.resolucionErrorTitle"
            ),
            detail: this.$t(
              "consulta.detalleConsulta.mensajes.resolucionError"
            ),
            life: 5000,
          });
        });
    },
    borrarArchivo(id) {
      this.$apollo
        .mutate({
          mutation: DELETE_FILE_BY_ID,
          variables: {
            id: id,
          },
        })
        .then(() => {
          this.search();
          this.$toast.add({
            severity: "success",
            summary: this.$t(
              "consulta.detalleConsulta.mensajes.resolucionExitosa"
            ),
            detail: this.$t(
              "consulta.detalleConsulta.mensajes.resolucionExitosa"
            ),
            life: 5000,
          });
        })
        .catch(() => {
          this.$toast.add({
            severity: "error",
            summary: this.$t(
              "consulta.detalleConsulta.mensajes.resolucionErrorTitle"
            ),
            detail: this.$t(
              "consulta.detalleConsulta.mensajes.resolucionError"
            ),
            life: 5000,
          });
        });
    },
    cerrarModal() {
      this.errorConfirmacionBorrado = [];
      this.documentoABorrar = HASH_FICHERO_A_BORRAR;
      this.displayConfirmation = false;
    },
    mostrarConfirmacion(id, tipo, clave, filename) {
      this.documentoABorrar = {
        id: id,
        tipo: tipo,
        clave: clave,
        filename: filename,
      };
      this.displayConfirmation = true;
    },
    mostrarSubirFichero() {
      this.displayUploadDocument = true;
    },
    subidaFicheroFinalizada() {
      this.displayUploadDocument = false;
      this.search();
      this.$toast.add({
        severity: "success",
        summary: this.$t("consulta.detalleConsulta.mensajes.resolucionExitosa"),
        detail: this.$t("consulta.detalleConsulta.mensajes.resolucionExitosa"),
        life: 5000,
      });
    },
  },
  apollo: {
    documentos: {
      query: GET_FILES_LIST,
      variables() {
        return {
          criteria: {
            filter: this.backendFilters,
            sort: this.sort,
            page: this.numPagina,
            size: this.tamPagina,
          },
        };
      },
      update(data) {
        this.loading = false;
        if (data.listaDocumento) {
          this.totalRecords = data.listaDocumento.totalElements;
          return data.listaDocumento.results;
        } else {
          this.totalRecords = 0;
          return [];
        }
      },
      fetchPolicy: "no-cache",
      skip() {
        return (
          this.tipo == null ||
          this.tipo == undefined ||
          this.clave == null ||
          this.clave == undefined
        );
      },
    },
  },
};
</script>


<style lang="scss" scoped>
</style>